import * as React from 'react';
import { Modal, Typography, Breadcrumbs, IconButton } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import {
  ChipContainer,
  StyledHeader,
  StyledModalBox,
} from './SelectedOverview.styled';

type AllSelectedTeamsModalProps = {
  open: boolean;
  handleOpen: () => void;
  handleClose: () => void;
  content: React.ReactNode;
};
const AllSelectedTeamsModal: React.FC<AllSelectedTeamsModalProps> = ({
  open,
  handleClose,
  content,
}) => {
  return (
    <Modal
      keepMounted
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <StyledModalBox>
        <StyledHeader>
          <Breadcrumbs aria-label="breadcrumb">
            <Typography>Select teams</Typography>
            <Typography color="primary">All selected teams</Typography>
          </Breadcrumbs>
          <IconButton aria-label="close" onClick={handleClose}>
            <ArrowBack />
          </IconButton>
        </StyledHeader>
        <ChipContainer id="modal-description">{content}</ChipContainer>
      </StyledModalBox>
    </Modal>
  );
};
export default AllSelectedTeamsModal;
